import React from 'react';
import { useLocation } from 'react-router-dom';
import AppProviders from '@/components/layout/AppProviders.jsx';
import LayoutShell from '@/components/layout/LayoutShell.jsx';
import ExtensionShell from '@/components/layout/ExtensionShell.jsx';

function Layout({ children }) {
    const location = useLocation();
    const pathname = location?.pathname || '';
    const isExtensionRoute = pathname.startsWith('/ext/');

    return (
        <AppProviders>
            {isExtensionRoute ? (
                <ExtensionShell>{children}</ExtensionShell>
            ) : (
                <LayoutShell>{children}</LayoutShell>
            )}
        </AppProviders>
    );
}

export default Layout;
